import { TierCode, tierImages } from "../model/tierAssets";

interface Props {
  tier: TierCode;
  size?: number;
}

export const TierIcon = ({ tier, size = 32 }: Props) => (
  <img
    src={tierImages[tier]}
    alt={tier}
    width={size}
    height={size}
    style={{ objectFit: "contain" }}
  />
);
